import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      options: { customProperties: true },
      light: {
        // info: colors.blue.lighten1,
        // warning: colors.amber.darken2,
        // success: colors.green.lighten2,
        // anchor: '#8c9eff',
        // primary: colors.purple,
        // secondary: colors.grey.darken1,
        // accent: colors.shades.black,
        error: colors.red.accent3,
        black: "#000000",
        white: "#FFFFFF",
        nubeAqua: "#339999",
        nubeGreen: '#8cd0ab',
        nubeYellow: '#fbb93e',
        nubeLightGrey:"#666666",
        nubeDarkGrey: "#333333",
        exportColor: '#009688',
        downloadColor: '#339999',
        jsonGreen: "#13ce66",
        nubeLightBackground: "#eee",
        lightGrey: "#dfdfdf",
      },
      dark: {
        // info: colors.blue.lighten1,
        // warning: colors.amber.darken2,
        // success: colors.green.lighten2,
        // primary: colors.blueGrey.darken2,
        // secondary: colors.blueGrey.lighten2,
        // accent: colors.blueGrey.darken3,
        error: colors.red.accent4,
        black: "#000000",
        white: "#FFFFFF",
        nubeAqua: "#339999",
        nubeGreen: '#8cd0ab',
        nubeYellow: '#fbb93e',
        nubeLightGrey:"#666666",
        nubeDarkGrey: "#333333",
        exportColor: '#009688',
        downloadColor: '#339999',
        jsonGreen: "#13ce66",
        lightGrey: "#dfdfdf",
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
};

export default new Vuetify(opts);

// export default new Vuetify({
//   theme: {
//     themes: {
//       light: {
//         primary: colors.purple,
//         secondary: colors.grey.darken1,
//         accent: colors.shades.black,
//         error: colors.red.accent3,
//       },
//       dark: {
//         primary: colors.blueGrey.darken2,
//         secondary: colors.blueGrey.lighten2,
//         accent: colors.blueGrey.darken3,
//       },
//     },
//   },
// })
